import React from 'react';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';

// Lands directly on the pricing content. Pricing already carries its own
// heading, so there is no separate (repeated) page title.
export function PricingPage() {
  return <div data-id="element-672" data-mp="4z2ihwnplisa">
      <Pricing data-id="element-673" data-mp="9vsy6ivlqcd6" />
      <FAQ data-id="element-674" data-mp="9v9eawme5dwi" />
    </div>;
}